<div class="tasks-container" [tabIndex]="0" (keydown.enter)="addQuestion()">
	<div class="info-header">
		<mat-icon svgIcon="info" />

		{{ 'add_checklist_routine_info' | translate }}
	</div>
	<form [formGroup]="tasksForm" class="form">
		<div
			class="checklist-item-list nice-scroll colored-scroll-track visible-scroll"
			formArrayName="questions"
			cdkDropList
			[cdkDropListData]="questionsFormArray.controls"
			(cdkDropListDropped)="drop($event)"
		>
			@for (question of questionsFormArray.controls; track question; let i = $index) {
				<div class="question-card" cdkDrag [cdkDragDisabled]="!canEditTemplate()">
					<button mat-icon-button [disabled]="!canEditTemplate()">
						<mat-icon class="icons cursor-pointer" svgIcon="full-burger" cdkDragHandle />
					</button>
					<div class="question">
						<mat-form-field class="wide-form-field">
							<input matInput [formControlName]="i" (blur)="emitFormValues()" />
						</mat-form-field>
					</div>
					<button mat-icon-button [disabled]="!canEditTemplate()">
						<mat-icon class="icons" svgIcon="delete" (click)="removeQuestion(i)" />
					</button>
				</div>
			}
		</div>
	</form>

	<div class="footer-action">
		<button
			mat-icon-button
			class="tonal-icon-button"
			[disabled]="!canEditTemplate()"
			(click)="addQuestion()"
		>
			<mat-icon svgIcon="add" />
		</button>
	</div>
</div>
